/**
 * subscribe the pudu resources
 */
import Image from 'next/image'
import emailIcon from '../../public/icons/mail.svg'
import validEmailIcon from '../../public/icons/valid-mail.svg'
import hoverValidEmailIcon from '../../public/icons/valid-mail-hover.svg'
import { KeyboardEvent, ChangeEvent, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { subscribe } from '../../service/support.service'
import { EventReportManager } from '../../event-report/event-report-manager'
import { sha256 } from '../../common/misc'
import { useTranslations } from 'next-intl'

function Subscribe() {
  const t = useTranslations()
  const inputRef = useRef<HTMLInputElement>(null)
  const [validEmail, setValidEmail] = useState<boolean>(false)
  const [validEmailIconHolder, setValidEmaiIconHolder] = useState(validEmailIcon)
  const [message, setMessage] = useState<string>('')
  const timeoutHandlerRef = useRef<number>()

  function doShowTip(message: string) {
    setMessage(message)

    if (timeoutHandlerRef.current !== void 0) {
      clearTimeout(timeoutHandlerRef.current)
    }

    timeoutHandlerRef.current = window.setTimeout(() => {
      setMessage('')
    }, 3000)
  }

  function handleInputChange(evt: ChangeEvent<HTMLInputElement>) {
    if (!inputRef.current) {
      return
    }

    const text = evt.target.value
    inputRef.current?.reportValidity()
    setValidEmail(inputRef.current.checkValidity())
  }

  async function submit() {
    const value = inputRef.current?.value
    const passed = inputRef.current?.checkValidity()
    if (!passed || !value) {
      return
    }

    const email = value!.trim()
    const sha256Email = await sha256(email)
    subscribe(email)
      .then((res) => {
        if (res.code === 200) {
          doShowTip(t('Subscribe.success'))
          const evt = { data: { event: 'subscribe', sha256_email_address: sha256Email } }
          EventReportManager.getInstance().fireEventImmediately(evt, true)
        } else {
          doShowTip(res.message)
        }
      })
      .catch((err) => {
        doShowTip(err.message)
      })
  }

  function handleKeyUp(evt: KeyboardEvent<HTMLInputElement>) {
    const keyCode = evt.keyCode
    const enterKeyCode = 13
    if (keyCode === enterKeyCode) {
      submit()
    }
  }

  return (
    <div className="h-14 flex-col justify-end items-start gap-1 inline-flex">
      <span className="elf-stretch text-black/90 text-xs font-normal leading-snug">{t('Subscribe.title')}</span>
      <div className="h-30px inline-flex flex-row justify-start outline outline-1 outline-[#bbc3ce]">
        <input
          ref={inputRef}
          type="email"
          required
          className={[
            'appearance-none focus:ring-0 h-full flex-1 border-none placeholder:text-black/40 text-black/90 text-xs placeholder:text-xs',
          ].join(' ')}
          placeholder={t('Subscribe.placeholder')}
          onChange={handleInputChange}
          onKeyUp={handleKeyUp}
        />
        <a
          onClick={submit}
          className="inline-flex justify-center w-42px h-full bg-[#bbc3ce] rounded-tr-sm rounded-br-sm cursor-pointer mr-[-1px]"
        >
          <Image
            alt="email"
            src={validEmail ? validEmailIconHolder : emailIcon}
            onMouseOver={() => setValidEmaiIconHolder(hoverValidEmailIcon)}
            onMouseLeave={() => setValidEmaiIconHolder(validEmailIcon)}
          />
        </a>
      </div>
      <span className="text-black/60 text-xs font-normal">{message}</span>
    </div>
  )
}

export default Subscribe
